// Pump-counter fill form rules shared by the website and the Android app.

/**
 * Litres as typed at the pump: digits and one decimal point, at most 3
 * decimals. A comma is a decimal point here (some phone keypads type one);
 * litres are never written with thousands separators.
 */
export function cleanLitresInput(raw: string): string {
  const s = raw.replace(/,/g, '.').replace(/[^\d.]/g, '');
  const dot = s.indexOf('.');
  if (dot < 0) return s;
  return `${s.slice(0, dot)}.${s.slice(dot + 1).replace(/\./g, '').slice(0, 3)}`;
}

/** Why the Save button is disabled, in the order the attendant should fix them. */
export function saveBlockers(input: { litresTyped: string; litresValid: boolean; photoMissing: boolean; scanNotReviewed: boolean; confirmed: boolean; over: boolean }): string[] {
  const out: string[] = [];
  if (!input.litresTyped.trim()) out.push('Enter the litres from the pump display.');
  else if (!input.litresValid) out.push('Litres look wrong. Use digits with up to 3 decimals, like 22.825.');
  if (input.photoMissing) out.push('Take a photo of the receipt or pump display. This customer requires it.');
  if (input.scanNotReviewed) out.push('Tick “I checked the photo” after checking the numbers read from it.');
  if (input.over) out.push('This is more than approved. Do not save more than the limit.');
  if (!input.confirmed) out.push('Tick “I gave this fuel” to confirm.');
  return out;
}
